import { Button, Spinner } from '@chakra-ui/react'

import { PlusIcon } from '@/views/assets/PlusIcon'

interface AddInterviewerButtonProps {
  onClick: () => void
  isDisabled: boolean
  isLoading?: boolean
}

export const AddInterviewerButton = ({
  onClick,
  isDisabled,
  isLoading,
}: AddInterviewerButtonProps) => (
  <Button
    variant={'brand-solid-white'}
    rounded={'full'}
    mt={5}
    display="flex"
    alignItems="center"
    justifyContent="center"
    fontWeight={'bold'}
    onClick={onClick}
    isDisabled={isDisabled || isLoading}
  >
    {isLoading ? (
      <>
        <Spinner size="sm" />
        &nbsp;&nbsp;&nbsp;Adding...
      </>
    ) : (
      <>
        <PlusIcon stroke={'black'} />
        &nbsp;&nbsp;&nbsp;Add interviewer
      </>
    )}
  </Button>
)
